/**
 * @desc 标记已读
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageUser.markRead.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageUser/markRead`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
